import usePassengerInformationFormStep2 from '../../../../../viewModels/flights/passenger.information.form.step2.viewModel';
import ActivityIndicator from '../../../../share/components/activityIndicator';
import SvgIcon, { iconList } from '../../../../share/components/iconSVG';
import '../../styles.css';
import TabletItinerary from '../tabletItinerary';
import TabletPassengers from '../tabletPassengers';

const TableSection = ({ children, title }) => {
  return (
    <div className='tabletContainerSection'>
      <p className='tabletContainerSectionName'>{title}</p>
      {children}
    </div>
  )
}

const KeyValueRow = ({ keyName, value }) => {
  return (
    <div className='tabletContainerRow'>
      <p className='tabletContainerRowKey'>{keyName}</p>
      <p className='tabletContainerRowValue'>{value}</p>
    </div>
  )
}

function Step2({
  setStep,
  controlNumberPNR,
  setGlobalPNR,
  dataSavePNR,
}) {
  const {
    codePNR,
    getCodePNR,
    consultReservation,
    isFetching,
    recoveryResponse,
    buttonAvailable,
    continueTo,
  } = usePassengerInformationFormStep2(
    setStep,
    controlNumberPNR,
    setGlobalPNR,
  );

  return (
    <div className='pifsStepContainer'>
      <div className='pifsFormBodyInputsStepsContainer'>
        <div className='pifsFormBodyInputs'>
          <p className='pifsFormBodyInputsTitle'>
            Ingrese el codigo de reserva (PNR)
          </p>
          <div className='pifsFormBodyInputsLabelContainerCenter'>
            <input
              id=''
              type='text'
              placeholder='ABCDEF'
              value={`${codePNR}`}
              onChange={getCodePNR}
              className='pifsFormBodyInputsLabelContainerInput'
              name=''
              autoComplete="off"
              required={true}
            />
          </div>
        </div>
      </div>
      <div className='pifsFormFootBtnCenter'>
        <div onClick={() => buttonAvailable && consultReservation()}
          className={`pifsFormFootBtn  ${buttonAvailable ? 'pifsFormFootBtnOn' : 'pifsFormFootBtnOff'}`}>
          {isFetching ?
            <ActivityIndicator colorFill='#FFFFFF' size={20} />
            :
            <p className='pifsFormFootBtnText'>Consultar</p>
          }
        </div>
      </div>
      {
        recoveryResponse && !isFetching &&
        <>
          {
            recoveryResponse?.error
              ?
              <div className='sectionError'>
                <p className='sectionErrorTitle'>{recoveryResponse?.error}</p>
                <p className='sectionErrorDescription'>Revise que el código ingresado sea el correcto e intente nuevamente.</p>
              </div>
              :
              <div className='tabletContainer'>

                {/* <TableSection title='Reservacion'>
                  <KeyValueRow
                    keyName={'codigo'}
                    value={recoveryResponse?.pnr?.pnrHeader?.reservationInfo?.reservation?.controlNumber}
                  />
                </TableSection> */}


                <TabletPassengers
                  list={dataSavePNR?.travellers}
                  title={'Información de los pasajeros'}
                />
                <TabletItinerary
                  list={dataSavePNR?.itinerary}
                  title={'Información del Itinerario'}
                />

                {/* <TableSection title='Vuelo de ida'>
                <KeyValueRow
                  keyName={'Origen'}
                  value={dataSavePNR?.itinerary[0]?.from}
                />
                <KeyValueRow
                  keyName={'Destino'}
                  value={dataSavePNR?.itinerary[0]?.to}
                />
                <KeyValueRow
                  keyName={'Fecha'}
                  value={dataSavePNR?.itinerary[0]?.dateDeparture.split('T')[0]}
                />
                <KeyValueRow
                  keyName={'Hora'}
                  value={dataSavePNR?.itinerary[0]?.dateDeparture.split('T')[1].split('+')[0]}
                />
                <KeyValueRow
                  keyName={'Tipo de ruta'}
                  value={dataSavePNR?.itinerary[0]?.scale ? 'Con escala' : 'Directo'}
                />
              </TableSection> */}


                {/* {
                dataSavePNR?.itinerary.length > 0 &&
                <TableSection title='Vuelo de Regreso'>
                  <KeyValueRow
                    keyName={'Origen'}
                    value={dataSavePNR?.itinerary[1]?.from}
                  />
                  <KeyValueRow
                    keyName={'Destino'}
                    value={dataSavePNR?.itinerary[1]?.to}
                  />
                  <KeyValueRow
                    keyName={'Fecha'}
                    value={dataSavePNR?.itinerary[1]?.dateDeparture.split('T')[0]}
                  />
                  <KeyValueRow
                    keyName={'Hora'}
                    value={dataSavePNR?.itinerary[1]?.dateDeparture.split('T')[1].split('+')[0]}
                  />
                  <KeyValueRow
                    keyName={'Tipo de ruta'}
                    value={dataSavePNR?.itinerary[1]?.scale ? 'Con escala' : 'Directo'}
                  />
                </TableSection>
              } */}



                <div className='pifsFormFootBtnCenter'>
                  <div onClick={() => continueTo()} className={`pifsFormFootBtn pifsFormFootBtnOn }`}>
                    {isFetching ?
                      <ActivityIndicator colorFill='#FFFFFF' size={20} />
                      :
                      <p className='pifsFormFootBtnText'>continuar</p>
                    }
                  </div>
                </div>
              </div>

          }
        </>
      }









    </div>
  )
}

export default Step2;